import { loadingButton } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'loadingButton',
  label: 'Loading Button',
  category: 'Inputs',
  image: loadingButton
};
